import React from "react";

const PaginationPage = ({number, isActive, onClick}) => {
    if (!number) {
        return <span className="zw-pagination__page">...</span>
    }
    if (isActive) {
        return <span className="zw-pagination__page zw-pagination__page--active">{number}</span>
    }
    return <button
        onClick={onClick}
        className='zw-pagination__page'
    >{number}</button>
};

const Pagination = ({className, page, pagesTotal, onClick, pagesCap}) => {
    pagesCap = Math.max(pagesCap, 7);
    let pageNumbers;
    if (pagesTotal >= pagesCap) {
        if (page < 5) {
            pageNumbers = [];
            for(let i=1, j=pagesCap-2; i<=j; i++) {
                pageNumbers.push(i);
            }
            pageNumbers.push(null);
            pageNumbers.push(pagesTotal);

        } else if (page > pagesTotal - 4) {
            const offset = pagesTotal - 4;
            pageNumbers = [1, null];
            for(let i=0, j=pagesCap-2; i<j; i++) {
                pageNumbers.push(i+offset);
            }
        } else {
            const offset = page - Math.floor((pagesCap - 4) / 2);
            pageNumbers = [1, null];
            for(let i=0, j=pagesCap-4; i<j; i++) {
                pageNumbers.push(i+offset);
            }
            pageNumbers.push(null);
            pageNumbers.push(pagesTotal);
        }
    } else {
        pageNumbers = [];
        for (let i = 1, j = pagesTotal; i <= j; i++) {
            pageNumbers.push(i);
        }
    }

    return <nav className={`zw-pagination ${className}`}>
        {pageNumbers.map(
            (i, index) => <PaginationPage key={i || `null-${index}`}
                                          number={i}
                                          isActive={i == page}
                                          onClick={() => onClick(i)}/>)}
    </nav>
};

export default Pagination
